import "bootstrap/scss/bootstrap.scss";
import "@progress/kendo-theme-default/dist/default-ocean-blue.scss";

import "./themes/wib.css";

import * as React from "react";
import * as ReactClient from "react-dom/client";

import App from "./components/App";

const element = document.getElementById("app-container");
const root = ReactClient.createRoot(element);

root.render(<App />);
